export default __webpack_public_path__ + "static/media/round-action-info.47a2127f.svg";